import React from "react";
import { NavLink } from "react-router-dom";
import aboutImg from "../Images/about_us_problem_solver.jpeg";
import "../Style/home&about.css";
import Image from "react-bootstrap/Image";
import NavbarTag from "react-bootstrap/Navbar";




const About = () => {
  return (
    <div className="main-section about-page">
      <section>
        <NavbarTag expand="lg">
          <NavLink
            exact
            to="/"
            className="listItem"
            activeclassname="activeItem"
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className="listItem"
            activeclassname="activeItem"
          >
            About
          </NavLink>
          <NavLink
            to="/contact"
            className="listItem"
            activeclassname="activeItem"
          >
            Contact
          </NavLink>
          <NavLink
            to="/products"
            className="listItem"
            activeclassname="activeItem"
          >
            Products
          </NavLink>
          <NavLink
            to="/services"
            className="listItem"
            activeclassname="activeItem"
          >
            Services
          </NavLink>
        </NavbarTag>
      </section>

      <div className="about-page-inner">
        <div className="contentBox about-page-copy">
          <h1>Bara Company B.V.</h1>

          <blockquote lang="he">
            <span className="about-etymology">
              <em>bara</em> is a Hebrew word (<span dir="rtl">בָּרָא</span>), meaning <q>to create</q>.
            </span>
          </blockquote>

          <p>
            Bara is a privately held company, with a mission to make your Kubernetes cluster
            self-aware.
          </p>

          <p className="about-kvk">
            Registered with the Chamber of Commerce of the Netherlands (KVK 90384237).
          </p>
        </div>

        <figure className="about-page-media">
          <Image
            src={aboutImg}
            alt="Illustration for Bara Company"
            className="about-page-image"
          />
        </figure>
      </div>
    </div>
  );
};

export default About;
